"use client";
import { usePathname } from "next/navigation";

export default function WhatsAppButton() {
  const pathname = usePathname();
  if (pathname === "/admin" || pathname.startsWith("/admin/")) return null;
  return (
    <a
      href="https://wa.me/551142805787"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Agendar demonstração gratuita pelo WhatsApp"
      style={{
        position: "fixed",
        bottom: "28px",
        right: "28px",
        zIndex: 9999,
        width: "56px",
        height: "56px",
        borderRadius: "50%",
        backgroundColor: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 16px rgba(0,0,0,0.22)",
        transition: "transform 0.2s, box-shadow 0.2s",
      }}
      onMouseEnter={e => {
        (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1.1)";
        (e.currentTarget as HTMLAnchorElement).style.boxShadow = "0 6px 24px rgba(0,0,0,0.30)";
      }}
      onMouseLeave={e => {
        (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1)";
        (e.currentTarget as HTMLAnchorElement).style.boxShadow = "0 4px 16px rgba(0,0,0,0.22)";
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="30"
        height="30"
        fill="white"
        aria-hidden="true"
      >
        <path d="M16.001 2.667C8.637 2.667 2.667 8.637 2.667 16c0 2.363.627 4.663 1.817 6.681L2.667 29.333l6.84-1.792A13.277 13.277 0 0 0 16.001 29.333c7.364 0 13.332-5.97 13.332-13.333 0-7.363-5.968-13.333-13.332-13.333zm0 24.267a11.01 11.01 0 0 1-5.617-1.542l-.402-.24-4.062 1.064 1.083-3.953-.263-.416A10.972 10.972 0 0 1 5.001 16c0-6.075 4.926-11 11-11s11 4.925 11 11-4.926 11-11 11zm6.03-8.237c-.33-.165-1.953-.963-2.256-1.073-.303-.11-.524-.165-.744.165-.221.33-.854 1.073-1.047 1.293-.193.22-.385.248-.715.083-.33-.166-1.393-.514-2.654-1.637-.98-.874-1.642-1.952-1.834-2.282-.193-.33-.021-.508.145-.672.15-.148.33-.385.495-.578.165-.192.22-.33.33-.55.11-.22.055-.413-.028-.578-.083-.165-.744-1.793-1.02-2.454-.268-.644-.54-.557-.744-.567l-.633-.011c-.22 0-.578.082-.88.412-.303.33-1.155 1.129-1.155 2.753s1.182 3.194 1.347 3.414c.165.22 2.326 3.552 5.636 4.982.788.34 1.402.543 1.882.695.79.252 1.51.216 2.078.131.634-.094 1.953-.798 2.228-1.569.275-.77.275-1.43.192-1.568-.082-.138-.302-.22-.633-.385z" />
      </svg>
    </a>
  );
}
